//
// Imports
//

import { getElementOrThrow } from "@lorenstuff/browser-utilities";

//
// Locals
//

async function initialise(element: HTMLElement)
{
	if (element.classList.contains("collapsed"))
	{
		const expand = getElementOrThrow(element, ".expand");

		expand.addEventListener("click", () =>
		{
			element.classList.remove("collapsed");

			// element.scrollIntoView(
			// 	{
			// 		behavior: "smooth",
			// 	});
			
			expand.remove();
		});
	}

	element.classList.add("initialised");
}

//
// Component
//

export async function initialiseBlocks()
{
	const elements = document.querySelectorAll<HTMLElement>(".component-block:not(.initialised)");

	for (const element of elements)
	{
		initialise(element)
			.then(() => console.log("[Block] Initialised:", element))
			.catch((error) => console.error("[Block] Error:", element, error));
	}
}